// API abstraction for ຮ້ານຄ້າຖອນ COD ລ່ວງໜ້າ.
// Flip USE_MOCK to false (or set VUE_APP_USE_MOCK_COD=false) once the backend is ready —
// component code stays unchanged because the function signatures stay the same.

import { ADVANCE_COD_STORES, ADVANCE_COD_CUSTOMERS, nextMockId } from './mockData';

const USE_MOCK = (process.env.VUE_APP_USE_MOCK_COD ?? 'true') !== 'false';

const SIMULATED_LATENCY_MS = 250;
const wait = (data) => new Promise((resolve) => setTimeout(() => resolve(data), SIMULATED_LATENCY_MS));

// In-memory copy so demos can add/edit without losing changes during the session.
let store = ADVANCE_COD_STORES.map((s) => ({ ...s }));

function paginate(list, page, perPage) {
  const start = (page - 1) * perPage;
  const data = list.slice(start, start + perPage);
  return {
    data,
    total: list.length,
    current_page: page,
    per_page: perPage,
    last_page: Math.max(1, Math.ceil(list.length / perPage)),
  };
}

function applyFilters(list, { search, is_active }) {
  let result = list;
  if (search) {
    const q = String(search).toLowerCase();
    result = result.filter((s) =>
      (s.name || '').toLowerCase().includes(q) ||
      (s.customer_tel || '').toLowerCase().includes(q)
    );
  }
  if (is_active === 'true') result = result.filter((s) => s.is_active);
  if (is_active === 'false') result = result.filter((s) => !s.is_active);
  return result;
}

// ---------- Public API (these signatures must match the real backend) ----------

export function fetchAdvanceCodStores(http, params = {}) {
  if (USE_MOCK) {
    const page = params.page || 1;
    const perPage = params.per_page || 10;
    const filtered = applyFilters(store, params);
    return wait({ data: paginate(filtered, page, perPage) });
  }
  return http.get('v2/auth/corporate/advance-cod-withdraw/stores', { params });
}

export function createAdvanceCodStore(http, payload) {
  if (USE_MOCK) {
    const item = {
      id: nextMockId(),
      name: payload.name,
      customer_tel: payload.customer?.tel || '',
      created_at: new Date().toISOString(),
      is_active: payload.is_active,
      withdraw_percent: Number(payload.withdraw_percent) || 0,
      fee_percent: Number(payload.fee_percent) || 0,
      customer: payload.customer,
      completed_cod: 0,
      pending_cod: 0,
    };
    store.unshift(item);
    return wait({ data: item });
  }
  return http.post('v2/auth/corporate/advance-cod-withdraw/stores', payload);
}

export function updateAdvanceCodStore(http, id, payload) {
  if (USE_MOCK) {
    store = store.map((s) =>
      s.id === id
        ? { ...s, ...payload, customer_tel: payload.customer?.tel || s.customer_tel }
        : s
    );
    return wait({ data: store.find((s) => s.id === id) });
  }
  return http.put(`v2/auth/corporate/advance-cod-withdraw/stores/${id}`, payload);
}

export function fetchAdvanceCodCustomers(http, params = {}) {
  if (USE_MOCK) {
    const q = (params.search || '').toLowerCase();
    const result = q
      ? ADVANCE_COD_CUSTOMERS.filter(
          (c) => c.name.toLowerCase().includes(q) || c.tel.includes(q)
        )
      : ADVANCE_COD_CUSTOMERS;
    return wait({ data: { data: result, total: result.length } });
  }
  return http.get('v2/auth/corporate/advance-cod-withdraw/customers', { params });
}
